import { $, $$, closest } from 'utils/dom';

const columnsSliders = $$('.columns-slider');
if (columnsSliders.length) {
  Promise.all([import('flickity'), import('flickity-imagesloaded')]).then(_ => {
    columnsSliders.forEach(target => {
      const Flickity = _[0].default;
      const slideNav = $('.columns-slider__current', target);
      const carousel = $('.columns-slider__wrapper', target);

      carousel.classList.remove('is-hidden');
      // eslint-disable-next-line no-unused-expressions
      carousel.offsetHeight;

      const slider = new Flickity(carousel, {
        cellAlign: 'center',
        wrapAround: true,
        pageDots: false,
        imagesLoaded: true,
        contain: true,
        arrowShape:
          'M32.6788 42.6722h69.7046v17.0224h-69.7869l30.649 30.649-12.0732 12.0732-51.1556-51.1556 51.3111-51.3111 12.0366 12.0366-30.6856 30.6856z',
      })
        .on('change', index => {
          slideNav && (slideNav.innerText = index + 1);
        })
        .on('staticClick', (event, pointer, cellElement, cellIndex) => {
          if (cellElement === slider.selectedElement) return;

          $$('a', cellElement).forEach(a => {
            const handleClick = e => {
              e.preventDefault();
              a.removeEventListener('click', handleClick);
            };

            a.addEventListener('click', handleClick);
          });

          slider.select(cellIndex);
        });

      $$('.columns-slider__item--inner', target).forEach(el =>
        el.addEventListener('focus', e => {
          const slide = closest(e.target, '.columns-slider__item');
          const index = slider.getCellElements().indexOf(slide);
          slider.select(index, false, false);
          // Prevents browser auto-scrolling
          slider.viewport.scrollLeft = 0;
        })
      );

      const sliderCounter = $('.columns-slider__count', target);
      sliderCounter && (sliderCounter.innerText = slider.cells.length);
    });
  });
}
